/*
 * add by tht 2017-9-12
 * for forum info operate function 
 * notes: delete editor zan cai
 */
(function(){
	var getEditedForumStatusUrl = "/forum/thread/edit"; //获取编辑主贴状态
	var acceptAnswerUrl = "/forum/thread/ask/accept"; //采纳回帖
    function DaoForumInfoOperate(){
        //constructure
    }
    DaoForumInfoOperate.prototype = {
        init:function(forumEditorObj){
        	var _this = this;
			_this.forumEditFn(forumEditorObj);
			_this.acceptAnswerFn();
        },
        //获取即将编辑主贴状态
        forumEditFn:function(forumEditorObj){
        	$(".js_replyList").off("click",".js_edit_forum").on("click",".js_edit_forum",function(){
        		var $this = $(this);
				
    			if($this.attr("data-status")=="true"){
    				$.ajax({
        				url:getEditedForumStatusUrl,
        				type:"get",
        				dataType:"json",
        				data:{
        					r:Math.random(),
        					threadId:$(document).getLinkParamFn("id")
        				},
    					beforeSend:function(){
    						$this.setBtnStatusFn("false","编辑");
    					},
        				success:function(d){
        					$this.setBtnStatusFn("true","编辑");
        					if(d.status=="success"){
        						//打开主贴层
        						if(d.data!==null){
        							var titles = d.data.title;
        							$("#newTopicTitle").val(titles); //标题
        							forumEditorObj.setContent(d.data.content); //内容
        							var con = forumEditorObj.getContentTxt();
        							if(con=="正文"||con==" "){
        								$(".js_editor_count").html("0");  //字体个数清零
        							}else{
        								var len = forumEditorObj.getContentLength(true);
        								$(".js_editor_count").html(len);  //字体个数清零
        							}

        							var tags = d.data.tags.length>0?d.data.tags.join(" "):"";  //没有标签时空数组
        							$(".js_oaSearchResult").val(tags);  //存默认标签
									if (d.data.isCommon && d.data.isAskAnswer) {
										$('.js_fatie li').each(function() {
											if ($(this).attr('data-type') === d.data.tags[0]) {
												$(this).addClass('on');
											}else {
												$(this).removeClass('on');
											}
										});
									}
        						}else{
        							
        							$("#newTopicTitle").val(""); //标题
        							forumEditorObj.setContent("<p>正文</p>"); //内容
        							$(".js_editor_count").html("0");  //字体个数清零
        							$(".js_tag_selected").html("");  //已选择标签
        							$(".js_oaSearchResult").val("");  //存默认标签
        						}
        						$("#OaSearchStaff").OaSearch();  //标签
								
								$("#forumPost").popPostF("open");
								//编辑时仅策划可见、求助、公告、发帖版块功能隐藏
								$("#forumPost").find(".js_planWrapper").hide();
								$("#forumPost").find(".js_helpWrapper").hide();
								$("#forumPost").find(".js_noticeWrapper").hide();
								// $("#forumPost").find(".js_forumVerWrapper").hide();
								$("#forumPost").find(".js_forumVerContent").css({
									"cursor": "not-allowed",
									"pointer-events": "none",
									"opacity": 0.7
								})
								if (d.data.moduleId != 1 && !d.data.tags.includes('你问我答')) {
									setTimeout(function () {
										$(".js_bankuantext").html(d.data.moduleName);
									},100)
								}
        					}else{
        						$(document).errorDataOperateFn(d);	
        					}
        				},
        				error:function(){
        					$this.setBtnStatusFn("true","编辑");
        					$(document).popErrorF({type:"open",tip:"程序小哥打盹儿了，刷新页面试试！"});
        				}
        			});
    			}
        			
        	});
		},
		/**
		 * @function acceptAnswerFn 求助帖采纳功能
		 */
		acceptAnswerFn:function(){
			var _this = this;
			$(".js_replyList").off("click",".js_acceptAnswer_replyForum").on("click",".js_acceptAnswer_replyForum",function(){
				var $this = $(this);
				$(document).popConfirmF({
					type:"open",
					tip:"每个提问只能选择一个满意回答，请谨慎操作",
					confirmFn:function(){
						$(document).popConfirmF({type:"close"}); //关闭确认弹层
						_this.acceptAnswerSubmitFn($this,$this.attr('data_replyid'));
					}
				});
        			
        	});
		},
		/**
		 * @function acceptAnswerSubmitFn 采纳回帖提交
		 * @param btn 回帖采纳按钮对象
		 * @param postId 回帖Id
		 */
		acceptAnswerSubmitFn:function(btn,postId){
			
			$.ajax({
				url:acceptAnswerUrl,
				type:"post",
				dataType:"json",
				data:{
					r:Math.random(),
					postId:postId
				},
				success:function(d){
					if(d.status=="success"){
						//主贴已回答标记与GM标记互斥,优先展示回答标记
						$('.js_sub_forum .iconAsk').removeClass('hide');
						$('.js_sub_forum .iconGm').addClass('hide');
						//楼层已采纳标记
						var thisReplyForumWrapObj = btn.parents('.js_replyF_info');
						thisReplyForumWrapObj.find('.js_answerAcceptIcon').removeClass('hide');
						//各楼层设置按钮
						var allReplyForumWrapObj = $('.js_replyList .js_replyF_info');
						allReplyForumWrapObj.each(function(){
							var $this = $(this);
							$this.find('.js_acceptAnswer_replyForum').addClass('hide');

						});
						//采纳成功前三次获得抽奖机会
						if(d.data.showLottery){
							$(document).popSuccF({
								type:"open",
								tip:"采纳成功,<a href='/user/action/index'>[去抽奖]</a>",
								countDownStatus:false,
								closeFn:function(){
									$(document).popConfirmF({type:"close"}); //关闭确认弹层
								}
							});
						}else{
							$(document).popSuccF({
								type:"open",
								tip:"采纳成功",
								countDownStatus:true,
								countDownCloseFn:function(){
									$(document).popConfirmF({type:"close"}); //关闭确认弹层
								},
								closeFn:function(){
									$(document).popConfirmF({type:"close"}); //关闭确认弹层
								}
							});
						}
						
					}else{
						$(document).popConfirmF({type:"close"}); //关闭确认弹层
						$(document).errorDataOperateFn(d);	
					}
					
				},
				error:function(){
					$(document).popErrorF({type:"open",tip:"程序小哥打盹儿了，刷新页面试试！"});
				}
			});
		}
    };
    window.daoForumInfoOperate = function(){
        return new DaoForumInfoOperate();
    };
})();